import axios from "axios";
import { hideLoader, showLoader } from "../utils/common-utils";

if (process.env.NODE_ENV === "development")
  axios.defaults.baseURL = "https://api.vocalresults.com/";
else axios.defaults.baseURL = "https://api.vocalresults.com/";

axios.interceptors.request.use(
  (config) => {
    if (config.showLoader === undefined) showLoader();

    if (config.token)
      config.headers.common = {
        ...config.headers.common,
        "X-Auth-Token": config.token,
      };
    return config;
  },
  function (error) {
    return Promise.reject(error);
  }
);

axios.interceptors.response.use(
  (response) => {
    if (response.config.showLoader === undefined) hideLoader();
    return response;
  },
  (error) => {
    const expectedError =
      error.response &&
      error.response.status >= 401 &&
      error.response.status < 500;

    if (error.response && error.response.status === 400) {
      // showErrorToast(errorMsg);
    } else if (!expectedError) {
      // showErrorToast("An unexpected error occured.");
    }

    hideLoader();

    return Promise.reject(error);
  }
);

// eslint-disable-next-line import/no-anonymous-default-export
export default {
  get: axios.get,
  post: axios.post,
  put: axios.put,
  delete: axios.delete,
};
